export default __webpack_public_path__ + "static/media/PartingImg.375f25c2.jpg";